import { alpha } from "@mui/material/styles";
import { PaletteOptions } from "@mui/material/styles";

import { sharedNeutrals } from "./shared";

export const darkPalette: PaletteOptions = {
  action: {
    disabled: "rgba(208, 213, 221, 0.45)",
    disabledBackground: "#252A34",
    focus: alpha("#F5F7FA", 0.16),
    hover: "#CDD2D9",
    selected: "#FEFEFE"
  },
  background: {
    default: "#1E2123",
    paper: "#262A2E"
  },
  border: {
    accent: "rgba(var(--mui-palette-primary-mainChannel) / 0.24)",
    default: "rgba(var(--mui-palette-primary-mainChannel) / 0.42)",
    // Stronger than the light scheme's 0.06 black. A card sits on a dark page
    // at almost its own value, so at 6% white its edge was too faint to find;
    // the light scheme has the page's white to separate against and needs no
    // such help.
    hairline: alpha("#FFFFFF", 0.072),
    strong: "#6B7280",
    subtle: "#FFFFFF1F"
  },
  divider: "rgba(255,255,255,0.12)",
  error: {
    contrastText: "#2B0B09",
    light: "rgba(249, 112, 102, 0.12)",
    // Lifted for a dark ground. The light scheme's #E84B27 sits at about a
    // fifth of the brightness the accent has here, so a status dot or a bar
    // drawn in it read as a smudge beside one drawn in the brand colour.
    main: "#F18C7E"
  },
  grey: {
    100: "#171A21",
    200: "#20242D",
    300: "#21221D",
    400: "#3A404C",
    500: "#98A2B3",
    600: "#B7C0CC",
    700: "#D0D5DD",
    800: "#E4E7EC",
    900: "#F5F7FA"
  },
  icon: {
    default: "#D0D5DD",
    inverse: "#000000",
    muted: "#98A2B3",
    strong: "#F5F7FA"
  },
  info: {
    main: "#4B47E0"
  },
  mode: "dark",
  overlay: {
    backdrop: "rgba(10, 13, 18, 0.45)",
    scrim: "rgba(10, 13, 18, 0.86)"
  },
  secondary: {
    contrastText: sharedNeutrals.black,
    dark: "#98A2B3",
    light: "#EAECF0",
    main: "#D0D5DD"
  },
  success: {
    contrastText: "#031B13",
    // See `error.main`: the light scheme's #1B9B76 is too dark to read here.
    main: "#71C1AA"
  },
  surface: {
    base: "#1D2022",
    elevated: "#24282B",
    inset: "#181B1C",
    overlay: "#262A2E",
    page: "#1E2123",
    subtle: "#1C1F21"
  },
  text: {
    disabled: "#7D848F",
    inverse: "#535862",
    primary: "#F5F7FA",
    quaternary: "#8A919B",
    secondary: "#CDD2D9",
    subtle: "#6B7280",
    tertiary: "#AAB1BA"
  },
  warning: {
    // See `error.main`: the light scheme's #E98945 is too dark to read here.
    main: "#F1B68C"
  }
};
